import React from 'react';
import { CampaignOrderQueueReviewQueueSummary } from './CampaignOrderQueueReviewQueueSummary';
import { CampaignOrderQueueReviewLaunchSummary } from './CampaignOrderQueueReviewLaunchSummary';

export const CampaignOrderQueueReviewSummary = ({
  currentCampaignOrder,
  setShowApprovedDialogSuccess,
}) => {
  return (
    <>
      {['PENDING', 'LIVE_PENDING', 'REJECTED'].includes(currentCampaignOrder.status) && (
        <CampaignOrderQueueReviewQueueSummary
          setShowApprovedDialogSuccess={setShowApprovedDialogSuccess}
        />
      )}
      {['APPROVED', 'LIVE_APPROVED'].includes(currentCampaignOrder.status) && (
        <CampaignOrderQueueReviewLaunchSummary />
      )}
    </>
  );
};
